import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Verkkokauppa',
        [PolygraphyProductUrlType.Storefront]: 'Storefront',
        [PolygraphyProductUrlType.Custom]: 'Mukautettu',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Tallenna muutokset nähdäksesi esikatselun',
  },
  buttons: {
    save_and_preview: 'Tallenna ja esikatsele',
  },
  toasts: {
    failed_to_load_data: 'Tuotteen lataaminen epäonnistui',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui!',
    changes_got_saved: 'Muutokset tallennettu!',
  },
};
